import styled from 'styled-components'

export const SummaryWrapper = styled.div`
  padding: 12px 24px 0;
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;

  @media (max-width: 1600px) {
    padding-top: 8px;
  }
`

export const SummaryLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 16px;
  padding: 3px 0;
  font-size: 0.95rem;
  color: var(--color-muted);

  span:last-child {
    color: var(--color-text);
    white-space: nowrap;
  }

  @media (max-width: 1600px) {
    padding: 1px 0;
    font-size: 0.9rem;
  }
`

export const DiscountLine = styled(SummaryLine)`
  font-weight: 600;
  color: var(--color-success);

  span:last-child {
    color: var(--color-success);
  }
`

export const SummaryTotal = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 16px;
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid var(--color-line);
  color: ${({ theme }) => theme.colors.global};

  span:first-child {
    font-size: 1.15rem;
    font-weight: 700;
  }

  span:last-child {
    font-size: 2.125rem;
    font-weight: 800;
    line-height: 1.1;
    letter-spacing: -0.01em;
    white-space: nowrap;
  }

  @media (max-width: 1600px) {
    margin-top: 6px;
    padding-top: 8px;

    span:last-child {
      font-size: 1.875rem;
    }
  }
`
